const isEnv = toggle =>
  toggle && (toggle.toLowerCase() === 'true' || toggle === '1')

export default isEnv
